import {
  BasePalette,
  NeutralPalette,
  PaletteOpacity,
  PrimaryGradientPalette,
  SecondaryGradientPalette,
  StandardPalette,
} from "@Palettes/mui-palette-extension";

const dsBase: BasePalette = {
  v100: "#FFFFFF",
  v200: "#101021",
};

const dsNeutral: NeutralPalette = {
  v100: "#A4AAB6",
  v200: "#8D94A4",
  v300: "#6F7386",
  v400: "#5E606F",
  v500: "#3D3F4F",
};

const dsSurface: NeutralPalette = {
  v100: "#F7F7F8",
  v200: "#F1F2F4",
  v300: "#EAEBEF",
  v400: "#DBDDE2",
  v500: "#C2C7CE",
};

const dsPrimary: StandardPalette = {
  v100: "#EDF8FF",
  v200: "#D6EFFF",
  v300: "#067AFF",
  v400: "#0066FF",
};

const dsSuccess: StandardPalette = {
  v100: "#E0FAF6",
  v200: "#ADF1E7",
  v300: "#00D3B3",
  v400: "#00BB9E",
};

const dsWarning: StandardPalette = {
  v100: "#FFF2ED",
  v200: "#FFDDCE",
  v300: "#FF9466",
  v400: "#FF814B",
};

const dsDestructive: StandardPalette = {
  v100: "#FFEDF0",
  v200: "#FFCED7",
  v300: "#FF6581",
  v400: "#FB4E6D",
};

const dsSecondaryPurple: StandardPalette = {
  v100: "#EAE8FF",
  v200: "#9785FF",
  v300: "#886AFF",
  v400: "#6430F7",
};

const dsSecondaryBrown: StandardPalette = {
  v100: "#F6EDE6",
  v200: "#E9D2C0",
  v300: "#C78F62",
  v400: "#A5744D",
};

const dsSecondaryYellow: StandardPalette = {
  v100: "#FFEED3",
  v200: "#FFE5BE",
  v300: "#FFC56E",
  v400: "#FEA725",
};

const dsPrimaryGradient: PrimaryGradientPalette = {
  blue: "linear-gradient(var(--gradient-direction), #48BCFF 0%, #084EC5 100%)",
  green: "linear-gradient(var(--gradient-direction), #76F2CD 0%, #159375 100%)",
  orange: "linear-gradient(var(--gradient-direction), #FFC880 0%, #E6742D 100%)",
  purple: "linear-gradient(var(--gradient-direction), #9785FF 0%, #6430F7 100%)",
  red: "linear-gradient(var(--gradient-direction), #FF9494 0%, #E93E3E 100%)",
  brown: "linear-gradient(var(--gradient-direction), #DBA575 0%, #965D38 100%)",
  grey: "linear-gradient(var(--gradient-direction),rgb(237, 237, 237) 0%,rgb(156, 156, 156) 100%)",
};

const dsSecondaryGradient: SecondaryGradientPalette = {
  green: "linear-gradient(var(--gradient-direction), #76F2CD 0%, #159375 100%)",
  orange: "linear-gradient(var(--gradient-direction), #FFC880 0%, #E6742D 100%)",
  red: "linear-gradient(var(--gradient-direction), #FF9494 0%, #E93E3E 100%)",
};

const dsOpacity: PaletteOpacity = {
  full: 1,
  high: 0.8,
  medium: 0.6,
  low: 0.4,
};

export {
  dsBase,
  dsDestructive,
  dsNeutral, dsOpacity, dsPrimary,
  dsPrimaryGradient,
  dsSecondaryBrown,
  dsSecondaryGradient,
  dsSecondaryPurple,
  dsSecondaryYellow,
  dsSuccess,
  dsSurface,
  dsWarning
};

